import React from 'react';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import { Link as RouterLink } from 'react-router-dom';
export default function Success(){
  return (
    <Container sx={{py:4}}>
      <Typography variant="h4" gutterBottom>Thank you!</Typography>
      <Typography>Your subscription was successful. You can now access the dashboard.</Typography>
      <Button component={RouterLink} to="/dashboard" variant="contained" sx={{mt:2}}>Go to Dashboard</Button>
    </Container>
  );
}
